<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6bBiMg/tc-custom/9781771422710.jpg?1702083785935" alt="This image is the cover for the book From No-Knead to Sourdough"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From No-Knead to Sourdough
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Cleverly combines science, history, and personal touches to make homemade bread accessible for everyone, no matter his or her level of experience.” —Meredith Leigh, author of <i>Pure Charcuterie</i></b><br/>  <br/> Is there any food that evokes pleasant memories and warm feelings more than bread? It’s the most basic of foods, yet many of us are intimidated by the prospect of making our own. “Artisan” bread, craft bakeries, and wood-fired pizza are gaining popularity—imagine creating these fabulous breads at home.<br/>  <br/> With <i>From No-Knead to Sourdough</i>, author Victoria Redhed Miller blends her own journey toward self-reliance with her fascination for traditional homesteading skills and love of good food. From making simple yeast breads, to learning how to bake a wide variety of sourdough-based breads, the author’s curiosity and fearlessness come together to share with readers a simpler approach to the pleasures of bread-baking.<br/>  <br/> Topics include:<br/> ·       Fitting bread-baking into your schedule<br/> ·       Low- and no-gluten baking, including GF sourdough breads<br/> ·       Using a wood-fired oven<br/> ·       Recipes for every comfort zone, from flatbread to sourdough<br/> ·       “Sexy science talk” sidebars for those interested in the science of baking.<br/>  <br/><i>From No-Knead to Sourdough</i> will inspire the beginner and the accomplished baker alike to find their own comfort zone and move on to new skills when they are ready. Pizza and bagels, flatbreads and loaf breads, even gluten-free breads—you become the artisan when you make your own bread.<br/>  <br/> “There are few things more soul-satisfying than the taste of homemade sourdough, and even fewer things as healthful to keep your mind and body tuned and balanced. Victoria’s detailed but uncluttered recipes make that argument, delectably.” —Stephen Yafa, author of <i>Grain of Truth</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victoria Redhed Miller
      </h2>
      
      <p class="authorDescription body article">Victoria Redhed Miller is a writer, photographer, and homesteader. She speaks and writes extensively on topics including home distilling, bread baking, poultry keeping, and more. Victoria lives on a 40-acre off-grid farm in Washington State, and is also the author of Pure Poultry and the award-winning Craft Distilling.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Society Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3308721f